import styled from '@emotion/styled'
import { breakpoints, colors, fonts, fontSizes } from 'src/utils/styles'
import { IS_BLACK_FRIDAY } from '../../utils/globals'

export const GridWrapper = styled.div`
  padding: 0 1.45rem 0 0;
  margin: 0 4.1rem 0 0;

  @media (max-width: ${breakpoints.xxl}px) {
    margin: 0 2.1rem 0 0;
  }

  @media (max-width: ${breakpoints.l}px) {
    margin: 0 0 0 0;
  }

  @media (max-width: ${breakpoints.s}px) {
    padding: 0;
    margin: auto;
  }
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-column-gap: 30px;
  grid-row-gap: 0.5em;
  justify-items: center;
  grid-auto-flow: dense;

  @media (max-width: ${breakpoints.xl}px) {
    grid-column-gap: 16px;
    grid-row-gap: 0.25em;
  }

  @media (max-width: ${breakpoints.s}px) {
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 16px;
  }
`

export const Product = styled.div`
  background-color: ${colors.lightGray};
  display: flex;
  flex-direction: column;
  max-width: 360px;
  width: 100%;
  height: auto;
`
export const ProductTwoColumns = styled(Product)`
  grid-area: auto / auto / span 1 / span 2;
  max-width: 750px;

  @media (max-width: ${breakpoints.s}px) {
    grid-area: auto / auto / span 1 / span 2;
  }
`
export const ProductFourColumns = styled(Product)`
  grid-area: auto / auto / span 2 / span 2;
  max-width: 750px;

  @media (max-width: ${breakpoints.s}px) {
    grid-area: auto / auto / span 2 / span 2;
  }
`

export const ProductTileInfo = styled.div`
  font-family: ${fonts.extendedSemiBold};
  font-size: ${fontSizes.productTileInfo};
  background-color: ${IS_BLACK_FRIDAY ? 'black' : 'white'};
  display: flex;
  flex-direction: column;
  min-height: 80px;
  max-height: 80px;
  padding-bottom: 20px;
  padding-top: 0.2em;

  @media (max-width: ${breakpoints.xl}px) {
    font-size: ${fontSizes.productTileInfoTablet};
    padding-top: 0;
  }

  @media (max-width: ${breakpoints.s}px) {
    font-size: ${fontSizes.productTileInfoMobile};
    min-height: 60px;
    max-height: 60px;
    padding-bottom: 0;
  }
`

export const Title = styled.span`
  text-align: start;
  overflow: hidden;
  font-family: ${fonts.extendedBold}, sans-serif;
`

export const TitleTwoColumnProduct = styled(Title)`
  max-width: 750px;
`

export const PriceTag = styled.span`
  font-family: ${fonts.regular};
  color: ${colors.midGray};
  text-align: start;
  font-size: ${fontSizes.specialLayoutTitle};
`

export const ViewMoreContainer = styled.div`
  display: flex;
  white-space: nowrap;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: 2.5rem 0;
  grid-column: span 4;

  @media (max-width: ${breakpoints.s}px) {
    margin: 1em 0 0 0;
    grid-column: span 2;
  }
`

export const ViewMoreButton = styled.button`
  all: unset;
  cursor: pointer;
  margin: 0.5em 0 0 0;
  padding: 0.55em 3em 0.75em 3em;
  border: 1px solid ${colors.darkGray};
  letter-spacing: 2px;
  text-align: center;
  text-transform: uppercase;
  font-size: ${fontSizes.resultsButton};

  @media (max-width: ${breakpoints.s}px) {
    width: 68%;
    margin: 0.4em 0 0 0;
    font-size: ${fontSizes.resultsButtonMobile};
  }
`

export const NumberOfResultsText = styled.span`
  font-family: ${fonts.regular};
  color: ${colors.gray};
  font-size: ${fontSizes.resultsText};

  @media (max-width: ${breakpoints.s}px) {
    font-size: ${fontSizes.resultsTextMobile};
  }
`
